export default {
    namespaced: true,
    state: () => ({
        manager: {
            id: null,
            authorityKbn: null,
            brandId: null,
            storeId: null,
            passwordIniflg: 0,
            storeManagerRole: null,
        }
    }),
    getters: {
        manager(state) {
            return state.manager
        },
        isInitPassword(state) {
            return state.manager.passwordIniflg
        },
        storeManagerRole(state) {
            return state.manager.storeManagerRole
        },
        exists(state) {
            return state.manager && state.manager.id && state.manager.authorityKbn
        },
        authorityKbn(state) {
            return state.manager.authorityKbn
        },
        authorityKbnName(state) {
            const kbn = {
                1: 'system',
                2: 'company',
                3: 'storeCommon',
                4: 'store',
                5: 'csvExport',
                6: 'other'
            }

            if (! Object.prototype.hasOwnProperty.call(kbn, state.manager.authorityKbn)) {
                return ''
            }

            return kbn[state.manager.authorityKbn]
        },
        brandId(state) {
            return state.manager.brandId
        },
        storeId(state) {
            return state.manager.storeId
        }
    },
    mutations: {
        setManager(state, manager) {
            state.manager = manager
        },
        logout(state) {
            state.manager = null
        },
        setStoreManagerRole(state, role) {
            state.manager.storeManagerRole = role
        },
        setPasswordInitFlg(state, flag) {
            state.manager.passwordIniflg = flag
        },
    },
    actions: {
        async login({commit}, {axios, cookies, endpoint, password}) {
            const res = await axios.post(endpoint + 'manage/auth/login', {
                password: password
            })
            // ログイン後に返ってきたユーザー情報
            let manager = res.data.manager
            // セッションCookieにトークンを保存
            cookies.set('api-token', manager.token, 0)
            // 店舗管理者（個別）のときはトークンを保存(期限：1ヵ月)
            if (manager.authorityKbn == 4) {
                cookies.set('user-api-token', manager.token, 60 * 60 * 24 * 30)
            }

            // storeにtoken以外の情報を保存
            manager.token = null
            commit('setManager', manager)
        },
        logout({commit}, cookies) {
            // Cookieの情報を空にする
            cookies.set('api-token', '', 0)
            commit('logout')
        },
        setStoreManagerRole({commit}, role) {
            commit('setStoreManagerRole', role)
        },
        setPasswordInitFlg({commit}, flag) {
            commit('setPasswordInitFlg', flag)
        },
    }
}
